module.exports = __webpack_public_path__ + "img/arrow-down.5a41b64a.svg";